/** How many inner grid squares a canvas icon occupies on each side. */
export const ICON_GRID_CELL_OPTIONS = [2, 3, 4, 5, 6, 8, 10, 12] as const;
export type IconGridCells = (typeof ICON_GRID_CELL_OPTIONS)[number];

/** Current 40px icons fill a 5×5 block when the grid is 8px. */
export const DEFAULT_ICON_GRID_CELLS: IconGridCells = 5;

export function parseIconGridCells(value: unknown): IconGridCells | undefined {
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return undefined;
  const rounded = Math.round(n);
  return (ICON_GRID_CELL_OPTIONS as readonly number[]).includes(rounded)
    ? (rounded as IconGridCells)
    : undefined;
}

/** Pixel size of a canvas icon so it fills `iconGridCells` inner squares. */
export function canvasIconSizePx(gridSize: number, iconGridCells: number): number {
  return Math.max(8, Math.max(1, Math.round(gridSize)) * Math.max(1, Math.round(iconGridCells)));
}

export function canvasIconGlyphSize(iconPx: number): number {
  return Math.max(10, Math.round(iconPx * 0.4));
}

export function canvasIconGlyphInset(iconPx: number): number {
  return Math.max(0, Math.round((iconPx - canvasIconGlyphSize(iconPx)) / 2));
}
